<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <span>{{ model.contract_name }} <br> {{ model.memo }}</span>
                            </v-col>
                        </v-row>
                        <v-row align-content="center">
                            <v-col class="thumb_wrap" v-for="(dbFile, index) in dbFileList" :key="`1st-${index}`">
                                <div class="thumb" v-show="dbFile.id" @click="toPdfPreview(dbFile)">
                                    <v-icon class="plus-icon" color="white">mdi-magnify</v-icon>
                                    <pdf-thumb-component :pdfData="dbFile.pdfData" :scale="1" max-width="196px" :suffixes="index"></pdf-thumb-component>
                                </div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span class="text-small" v-bind="attrs" v-on="on">{{ dbFile.contract_name | omittedText30 }}</span>
                                    </template>
                                    <span>{{ dbFile.contract_name }}</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                        <v-row align-content="center">
                            <v-col cols="12">
                                <div style="font-size: 1.5rem;"><sup>※</sup>設定した入力項目などはプレビューにてご確認ください</div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pb-0"><h3>■この契約の関係者</h3></v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col>
                                <workflow-component :items="destinationList" :user="user"></workflow-component>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="pb-0"><h3>■共有先</h3></v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col>
                                <div id="confirm-sticky-table" style="width: 100%;">
                                  <v-data-table :headers="headers" :items="sharingItems" hide-default-footer fixed-header>
                                    <template v-slot:body="props">
                                      <tbody>
                                        <tr v-for="(item, index) in sharingItems" :key="index" >
                                          <td class="td_order"><span>{{ index + 1 }}</span></td>
                                          <td class="td_name">
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">{{ item.share_destination_name }}</span>
                                              </template>
                                              <span>{{ item.share_destination_name }}</span>
                                            </v-tooltip>
                                          </td>
                                          <td class="td_email"> {{ item.share_destination_email_address }} </td>
                                          <td class="td_company"> {{ item.destination_company_name }} </td>
                                          <td class="td_actionBtn"><v-btn color="blue" class="white--text" @click="editItem(item)">編集</v-btn></td>
                                          <td class="td_actionBtn"><v-btn color="blue-grey" class="white--text" @click="confirmDialog(item)">削除</v-btn></td>
                                        </tr>
                                      </tbody>
                                    </template>
                                    <template v-slot:footer>
                                        <tr><td colspan=7 ><v-btn @click="addItem" color="orange" class="white--text">共有先を追加</v-btn></td></tr>
                                    </template>
                                  </v-data-table>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <label-component horizontal="left">■親展書類</label-component>
                                <v-radio-group v-model="stateIsConfidential" row >
                                    <v-radio label="親展書類として送信しない" :value="0"></v-radio>
                                    <v-radio label="親展書類として送信する" :value="1"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row  v-if="isPaid">
                            <v-col>
                                <label-component horizontal="left">■署名方式</label-component>
                                <v-radio-group v-model="signMethod" row >
                                    <v-radio
                                        v-for="(value, name, index) in signatureMethods"
                                        :key="index"
                                        :label="value"
                                        :value="name">
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                            <badge-component tile content="任 意">
                                <label-component horizontal="left">■メッセージ</label-component>
                            </badge-component>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <validation-provider v-slot="{ errors }" name="stateEmailMessage" rules="max:10000" >
                                    <v-textarea auto-grow outlined clearable v-disabled-icon-focus rows="3" :placeholder="messagePlaceholder" :error-messages="errors" v-model="stateEmailMessage" background-color="white"></v-textarea>
                                </validation-provider>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
            <div class="text-center pt-2">
                <v-btn color="red" class="white--text" :disabled="invalid||sending||sended" @click="confirmSendDialog = true">送信</v-btn>
            </div>
        </validation-observer>

        <!-- 共有先ダイアログ -->
        <sharing-dialog-component v-if="sharingDialog" :sharingDialog.sync="sharingDialog" :currentSharingList="sharingItems" :currentIndex="currentIndex" :currentItem="currentItem" @clickOk="changeEvent">
            <template v-slot:ok-btn>OK</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </sharing-dialog-component>
        
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="confirmDeleteDialog" :dialog.sync="confirmDeleteDialog" :currentItem="currentItem" :currentIndex="currentIndex" @clickOk="deleteItem(currentItem)" okBtn="削除" cancelbtn="キャンセル">
            <div>{{ currentItem.share_destination_name }}を削除しますか？</div>
        </simple-dialog-component>
        
        <!-- 送信確認ダイアログ -->
        <simple-dialog-component v-if="confirmSendDialog" :dialog.sync="confirmSendDialog" @clickOk="send" okBtn="送信する" cancelbtn="キャンセル">
            <div>書類の内容に同意のうえ送信しますか？</div>
        </simple-dialog-component>
    </div>
</template>

<script>
    import { required, max } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
    
    extend('required', {...required, message: '入力必須項目です',});
    extend('max', {
        ...max,
        message: '{length} 文字以内でご入力ください',
    });
    
    export default {
        components:{
            ValidationProvider,  // 入力時にリアルタイムでエラーチェック
            ValidationObserver   // 送信時にエラーチェック
        },
        props: {
            user: Object,
            model: Object,
            dbFileList: Array,
            destinationList: Array,
            sharingList: Array,
            isPaid: Boolean,
        },
        data() {
            return {
                sharingItems: null,
                stateIsConfidential: Boolean,
                stateEmailMessage: '',
                sharingDialog: false,
                confirmDeleteDialog: false,
                confirmSendDialog: false,
                headers: [
                    { text: '', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'share_destination_name', sortable: false },
                    { text: 'メールアドレス', value: 'share_destination_email_address', sortable: false },
                    { text: '会社名', value: 'destination_company_name', sortable: false, width: '50'  },
                    { text: '', value: 'edit', sortable: false, width: '75' },
                    { text: '', value: 'delete', sortable: false, width: '75' },
                ],
                sending: false,
                sended: false,
                messagePlaceholder: 'メールにメッセージを付けられます。(任意) \n ※受信者全員のメールに記載されます。', 
                message: {
                    success: false,
                    text: '',
                },
                signMethod: 'sign_long'
            };
        },
        filters: {
            omittedText(text) {
             // 11文字目以降は"…"
             return text.length > 10 ? text.slice(0, 10) + "…" : text;
            },
            omittedText30(text) {
             // 20文字目以降は"…"
             return text.length > 30 ? text.slice(0, 30) + "…" : text;
            }
        },
        // 初期表示のデータ
        created : function() {
            this.sharingItems = this.sharingList;
            this.stateIsConfidential = this.model.is_confidential;
            this.stateEmailMessage = this.model.email_message;
            this.signMethod = this.model.signature_method?? 'sign_long';
        },
        computed: {
            // isConfidential() {
            //     return this.model.is_confidential;
            // },
            // emailMessage() {
            //     return this.model.email_message;
            // },
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        mixins:[signatureMethodMixin],
        methods: {
            send: async function() {
                this.sending = true;
                let result = false;
                var self = this;
                await this.$refs.observer.validate().then( async function(validOk) {
                    if(validOk) {
                        try {
                            await window.axios
                                .post('confirm', {
                                    'sharingList': self.sharingItems,
                                    'email_message': self.stateEmailMessage,
                                    'is_confidential': self.stateIsConfidential,
                                    'signature_method': self.signMethod,
                                    'button': 'send'
                                })
                                .then(function (response) {
                                    if (response.data.success) {
                                        result = true;
                                        self.sended = true;
                                    } 
                                    else {
                                        result = false;
                                        if (response.data.message) {
                                            self.message.text = response.data.message;
                                        } else {
                                            self.message.text = "送信処理に失敗しました";
                                        }
                                        self.message.success = false;
                                    }
                                })
                                .catch(function (response) {
                                    result = false;
                                    console.log(response);
                                    self.message.text = "送信処理に失敗しました";
                                    self.message.success = false;
                                }
                            );
                            if (result) {
                                window.location = "/documents/dashboard?send=true&count=1";
                            }
                        }
                        finally {
                            self.sending = false;
                        }
                    }
                });
            },
            // 保存
            save: async function(draft = null) {
                let result = true;
                var self = this;
                await this.$refs.observer.validate().then( async function(validOk) {
                    if(validOk) {
                        await window.axios
                            .post('confirm', {
                                'sharingList': self.sharingItems,
                                'email_message': self.stateEmailMessage,
                                'is_confidential': self.stateIsConfidential,
                                'signature_method': self.signMethod,
                                'draft': draft,
                            })
                            .then(function (response) {
                                if (response.data.success) {
                                    result = true;
                                    self.sharingItems = response.data.newShareDestinations;
                                } 
                                else {
                                    result = false;
                                    if (response.data.message) {
                                        self.message.text = response.data.message;
                                    } else {
                                        self.message.text = "保存処理に失敗しました";
                                    }
                                    self.message.success = false;
                                }
                            })
                            .catch(function (response) {
                                result = false;
                                console.log(response);
                                self.message.text = "保存処理に失敗しました";
                                self.message.success = false;
                            }
                        );
                    }
                });
                return result;
            },
            addItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    // id: '',
                    share_destination_name: '',
                    share_destination_email_address: '',
                    destination_company_name: '',
                };
                this.sharingDialog = true;
            },
            editItem: function(item) {
                this.currentIndex = this.sharingItems.indexOf(item);
                this.currentItem = item;
                this.sharingDialog = true;
            },
            changeEvent: function(value) {
                if (this.currentIndex === null) {
                    this.sharingItems.splice(this.sharingItems.length, 0, value);
                } else {
                    this.$set(this.sharingItems, this.currentIndex, value);
                }
                this.currentItem = value;
            },
            confirmDialog: function(item) {
                this.currentIndex = this.sharingItems.indexOf(item);
                this.currentItem = item;
                this.confirmDeleteDialog = true;
            },
            deleteItem: function(item) {
                const index = this.sharingItems.indexOf(item);
                this.sharingItems.splice(index, 1);
            },
            // pdfプレビュー画面へ
            toPdfPreview: function(dbFile) {
                // 別タブで開く
                window.open('/documents/agreements/preview-contract/' + dbFile.object_id, '_blank');
            },
        },
    };
</script>

<style scoped lang="scss">
    /* table */
    ::v-deep th {
        padding: 5px 0!important;
        word-break: keep-all;
        white-space : nowrap;
    }
    ::v-deep td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0!important;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
    .td_order {
        width: 69px;
        text-align: center;
    }
    .td_name {
        width: 200px;
        max-width:400px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .td_email {
        /*width: 250px;*/
        padding-right: 15px !important;
    }
    .td_company {
        /*width: 250px;*/
        padding-right: 15px !important;
    }
    .td_actionBtn {
        width: 75px;
        text-align: center;
    }
    .thumb_wrap {
        width:240px;
        max-width: 240px;
        /*height:328px;*/
        /*max-height:328px;*/
    }
    .thumb {
        cursor : pointer;
        font-size: 14px;
        margin-left: 20px;
        position: relative;
    }
    .thumb:hover .plus-icon{
        opacity: 1;
        transform: scale(2, 2);
    }
    .plus-icon {
        cursor : pointer;
        opacity: 0;
        position: absolute;
        z-index:99;
        background-color:rgba(0,0,0,0.4);
        border-radius: 50%;
        top: 120px;
        left: 90px;
    }
</style>

<style>
    #confirm-sticky-table > div > div > table > tbody > tr:hover > td
    {
        background:#EEE !important;
    }

    /* datatableの列を固定化する(1列目) */
    #confirm-sticky-table > div > div > table > tbody > tr > td:nth-child(1),
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(1)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0px;
        z-index: 97;
        background:white;
    }
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(1)
    {
        z-index: 98;
    }
     
    /* datatableの列を固定化する(2列目) */
    /* 1列目の幅の分だけ、leftの値を増やして固定化する */
    #confirm-sticky-table > div > div > table > tbody > tr > td:nth-child(2),
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(2)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 65px;
        z-index: 97;
        background:white;
    }

    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(2)
    {
        z-index: 98;
    }
    
    /* datatableの列を固定化する(5列目) */
    /* 6列目の幅の分だけ、rightの値を増やして固定化する */
    #confirm-sticky-table > div > div > table > tbody > tr > td:nth-child(5),
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(5)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 75px;
        z-index: 97;
        background:white;
    }
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(5)
    {
        z-index: 98;
    }
    
    /* datatableの列を固定化する(6列目) */
    #confirm-sticky-table > div > div > table > tbody > tr > td:nth-child(6),
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(6)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0px;
        z-index: 97;
        background:white;
    }
    #confirm-sticky-table > div > div > table > thead > tr > th:nth-child(6)
    {
        z-index: 98;
    }
</style>
